/**
 * Lightweight event bus for agent → UI data refresh.
 *
 * When the agent completes a write tool (create project, add column, etc.),
 * the ChatWidget calls emitAgentDataChange() with the tool name.
 * Page components subscribe via useAgentDataRefresh() and re-fetch their data.
 */

const TOOL_TO_EVENT: Record<string, string> = {
  docscout_create_project: 'docscout:projects-changed',
  docscout_update_project: 'docscout:projects-changed',
  docscout_delete_project: 'docscout:projects-changed',
  docscout_duplicate_project: 'docscout:projects-changed',
  docscout_delete_documents: 'docscout:documents-changed',
  docscout_create_column: 'docscout:columns-changed',
  docscout_update_column: 'docscout:columns-changed',
  docscout_delete_column: 'docscout:columns-changed',
  docscout_start_analysis: 'docscout:analysis-changed',
  docscout_cancel_analysis: 'docscout:analysis-changed',
  docscout_submit_feedback: 'docscout:results-changed',
  docscout_create_template: 'docscout:templates-changed',
  docscout_add_member: 'docscout:members-changed',
  docscout_remove_member: 'docscout:members-changed',
};

/** Emit a data-change event for a completed agent tool. */
export function emitAgentDataChange(toolName: string): void {
  const eventName = TOOL_TO_EVENT[toolName];
  if (eventName) {
    window.dispatchEvent(new CustomEvent(eventName));
  }
}
